module.exports = __webpack_public_path__ + "assets/plus.4ccc559f.svg";